import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    fetchingNodes: false,
    nodes: [],
    node: null,
    addingNode: false,
    gettingNode: false,
    updatingNode: false,
    deletingNode: false,
    validatingNodeName: false,
    // Trusted sources
    fetchingTrustedSources: false,
    updatingTrustedSources: false,
  },
  mutations: {
    SET_FETCHING_NODES(state, value) {
      state.fetchingNodes = value
    },
    SET_NODES(state, value) {
      state.nodes = value.result
    },
    SET_NODE(state, value) {
      state.node = value.result
    },
    SET_ADDING_NODE(state, value) {
      state.addingNode = value
    },
    SET_GETTING_NODE(state, value) {
      state.gettingNode = value
    },
    UPDATING_NODE(state, settings) {
      state.node.planId = settings.planId
    },
    SET_UPDATING_NODE(state, value) {
      state.updatingNode = value
    },
    SET_DELETING_NODE(state, value) {
      state.deletingNode = value
    },
    SET_NODE_NAME(state, value) {
      state.validatingNodeName = value
    },
    // Trusted Sources
    SET_FETCHING_TRUSTED_SOURCES(state, value) {
      state.fetchingTrustedSources = value
    },
    SET_TRUSTED_SOURCES(state, value) {
      state.node = { ...state.node, trustedSources: value }
    },
    SET_UPDATING_TRUSTED_SOURCES(state, value) {
      state.updatingTrustedSources = value
    },
  },
  actions: {
    fetchNodes({ commit }, clusterId) {
      commit('SET_FETCHING_NODES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${clusterId}/nodes`)
          .then(res => {
            commit('SET_NODES', res.data)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_NODES', false)
          })
      })
    },
    getNode({ commit }, { clusterId, nodeId }) {
      commit('SET_GETTING_NODE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${clusterId}/nodes/${nodeId}`)
          .then(res => {
            commit('SET_NODE', res.data)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_NODE', false)
          })
      })
    },
    addNode({ commit }, { clusterId, node }) {
      commit('SET_ADDING_NODE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(`/projects/${getProjectId()}/clusters/${clusterId}/nodes/`, node)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_ADDING_NODE', false)
          })
      })
    },
    updateNode({ commit }, { clusterId, nodeId, settings }) {
      commit('SET_UPDATING_NODE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(`/projects/${getProjectId()}/clusters/${clusterId}/nodes/${nodeId}`, settings)
          .then(res => {
            commit('UPDATING_NODE', settings)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_NODE', false)
          })
      })
    },
    deleteNode({ commit }, { clusterId, id }) {
      commit('SET_DELETING_NODE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .delete(`/projects/${getProjectId()}/clusters/${clusterId}/nodes/${id}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DELETING_NODE', false)
          })
      })
    },
    validateNodeName({ commit }, { clusterId, name }) {
      commit('SET_NODE_NAME', true)
      return new Promise(resolve => {
        api('database')
          .head(`/projects/${getProjectId()}/clusters/${clusterId}/nodes/${name}`)
          .then(() => {
            resolve({ isValid: false, nameExists: true })
          })
          .catch(err => {
            if (err.response && err.response.status === 404) resolve({ isValid: true, nameExists: false })
            resolve({ isValid: false, nameExists: false })
          })
          .finally(() => {
            commit('SET_NODE_NAME', false)
          })
      })
    },
    // Trusted Sources
    fetchTrustedSourcesById({ commit }, { id, nodeId }) {
      commit('SET_FETCHING_TRUSTED_SOURCES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/sources/nodes/${id}?nodId=${nodeId}`)
          .then(res => {
            const sources = res.data?.result?.map(el => el.value)
            commit('SET_TRUSTED_SOURCES', sources)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_TRUSTED_SOURCES', false)
          })
      })
    },
    updateTrustedSources({ commit }, { sources, nodeId }) {
      commit('SET_UPDATING_TRUSTED_SOURCES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(`/projects/${getProjectId()}/sources/nodes/${nodeId}`, { sources })
          .then(res => {
            commit('SET_TRUSTED_SOURCES', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_TRUSTED_SOURCES', false)
          })
      })
    },
  },
}
